<template>
  <v-layout wrap justify-center class="pa-6">
    <v-flex xs12 md12>
      <v-card class="mx-auto col-12" max-width="1300" elevation="2">
        <v-card-title>
          <v-list-item>
            <v-list-item-icon>
              <v-icon size="30" color="blue darken-4 ">mdi-lock-alert</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="headline ml-2">Cierre Contable</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-title>
        <div class="pa-0 px-8">
          <v-card-text class="px-0 pa-0">
            <v-row>
              <v-col class="d-flex" cols="3">
                <v-menu
                  v-model="pickerPeriodo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="periodo_cargue"
                      label="Periodo"
                      append-icon="event"
                      hide-details
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="periodo_cargue"
                    type="year"
                    no-title
                    scrollable
                    @input="pickerPeriodo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="justify-end d-flex align-center">
                <v-btn
                  color="light-blue accent-4 white--text"
                  class
                  @click="cargarPeriodos()"
                  depressed
                >
                  <v-icon size="20" left>mdi-book-outline</v-icon>Buscar
                </v-btn>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col class="d-flex" cols="12" sm="4">
                <v-switch v-model="form.bloqueo" label="Bloqueo todo el año"></v-switch>
              </v-col>
            </v-row>

            <v-row class="d-flex mb-4 justify-center" no-gutters>
              <v-col class="mb-4" cols="6" sm="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="pa-0 px-0">
              <v-data-table
                :headers="headers"
                :items="contenido"
                :search="search"
                :single-expand="false"
                item-key="consecutivo"
                :loading="loader.tabla_datos"
                calculate-widths
                :sort-by="['consecutivo']"
                :sort-desc="[true, false]"
              >
                <template v-slot:item.action="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mr-4"
                        color="blue accent-3"
                        fab
                        small
                        icon
                        v-on="on"
                        outlined
                        @click="cerrar_mes(item)"
                      >
                        <v-icon>mdi-lock-alert</v-icon>
                      </v-btn>
                    {{ item.estado == "0" ? "Cerrado" : "Abierto"  }}                  

                    </template>
                    <span>Cerrar Mes</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </div>
      </v-card>
    </v-flex>
    <v-overlay :value="loader">
      <flower-spinner :animation-duration="2500" :size="100" color="#0d47a1" />
    </v-overlay>
  </v-layout>
</template>
<style lang="sass">
.v-data-table tbody tr.v-data-table__expanded__content
  box-shadow: none!important
  background: #f5f9ff
</style>
<script>
import { VMoney } from "v-money";
import post from "../../methods.js";
import { FlowerSpinner } from "epic-spinners";

export default {
  components: {
    FlowerSpinner
  },

  directives: { money: VMoney },
  data() {
    return {
      money: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false
      },
      dialogPicker: false,
      singleExpand: true,
      pickerPeriodo: false,
      periodo_cargue: this.$moment().format("YYYY"),
      contenido: [],
      search: "",
      form: null,
      drawer: false,
      headers: [
        { text: "", value: "data-table-expand", width: "5%", align: "center" },
        {
          text: "Periodo",
          align: "center",
          value: "periodo_cie",
          width: "15%"
        },
        { text: "Opciones", align: "center", value: "action", width: "15%" },        
        {
          text: "Fecha Cierre",
          align: "left",
          value: "fecha_cie",
          width: "5%"
        },
        {
          text: "Usuario",
          align: "left",
          value: "user_cie",
          width: "5%"
        }


      ],
      detalle: [],
      loader: {
        tabla_datos: false,
        tipoDocumento: false
      }
    };
  },
  created() {
    this.loader = false;
    this.form = {
      fecha_doc: this.$moment().format("YYYY")
    };
  },
  methods: {
    cargarPeriodos: function() {
      var fecha = this.periodo_cargue.replace(/\-/g, "");
      post
        .postData({
          url: "Financiero/dlls//PrCierreCbJ.dll",
          data: sessionStorage.Sesion + "|" + fecha + "|",
          method: ""
        })
        .then(data => {
          this.contenido = JSON.parse(JSON.stringify(data));
        })
        .catch(err => {
          this.loader.tipoDocumento = false;
          this.send_error("Error al cargar Documento Contable");
        });
    },
    cerrar_mes(data) {
      var item = JSON.parse(JSON.stringify(data));
      var periodo = item.periodo_cie;
      var estado = item.estado_cie;
      var bloqueo = this.form.bloqueo ? "1" : "0";

      this.loader = true;
      post
        .postData({
          url: "Financiero/dlls/PrCierreCb.dll",
          data: sessionStorage.Sesion +
          "|" +
          periodo + 
          "|" +
          bloqueo +
          "|" +
          estado +
          "|",
          method: ""
        })
        .then(data => {
          this.loader = false;
          this.cargarPeriodos();
          this.$emit("snack", {
            color: "success",
            text: "Periodo procesado",
            estado: true
          });
        })
        .catch(err => {
          this.loader = false;
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar registro",
            estado: true
          });
        });
    }
  }
};
</script>
